export { I18nModel } from './src/index';
